import { makeStyles } from '@material-ui/core/styles';

export const useTicketImageStyles = makeStyles(() => ({
  image: {
    height: 108,
    width: 108,
    objectFit: 'cover',
  },
}));

export const useTicketInformation = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 700,
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  ticket: {
    fontSize: 14,
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
}));

export const useTicketMobileStyles = makeStyles(() => ({
  container: {
    border: '1px solid #d9d9d9',
    padding: '26px 0px 29px 28px',
    '& :not(:last-child)': {
      marginRight: 13,
    },
    margin: '0px -16px 0px -16px',
  },
  link: {
    textDecoration: 'none',
    color: '#464646',
  },
  linkText: {
    textDecoration: 'none',
    color: 'black',
  },
}));

export const useTicketImageContainerStyles = makeStyles(() => ({
  skeleton: {
    height: 108,
    width: 108,
  },
}));
